/**
 * Roles Page
 */
import React from 'react';

const RolesPage = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Roles & Permissions</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Manage user roles and permissions</p>
    </div>
  );
};

export default RolesPage;
